// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__15Rhy","description":"PatientConsentPreview_description__2xQ4s"};